import React, { useCallback } from "react"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { invoiceAddPermissions } from "../../../Invoices/helpers/invoice-add-permissions.ts"
import { selectProjectWritePermissions } from "../../../Project/helpers/project-permissions.selectors.ts"
import { ProjectViewInvoicesList } from "../../../Project/ProjectViewPage/components/sections/ProjectViewInvoices/ProjectViewInvoices/ProjectViewInvoicesList.tsx"
import {
  TOUR_DEMO_INVOICES,
  TOUR_DEMO_PROJECT_ID
} from "../../content/tour-demo-data.ts"

/**
 * The REAL Project → Invoices table (`ProjectViewInvoicesList`,
 * presentational, confirmed with no internal `useSelector`/`connect`) fed
 * demo invoices — one of which (`demo-invoice-cabinets`) carries a `lines`
 * entry pointing back at the Cabinets milestone's Finance line, the same
 * way a real generated invoice does, so the tour can show the connection
 * end to end: Milestone → Finance line → Invoice. `persistColumnConfig=
 * {false}` below keeps a demo column drag/resize/reset local rather than
 * overwriting every real project's saved Invoices layout, which is keyed
 * by the same `TABLE_SURFACES.projectInvoices` surface.
 */
export const DemoProjectInvoicesSection = () => {
  const userId = useAppSelector(
    (state) => state.auth.userInfo?.id ?? "demo-user"
  )
  const projectPermissions = useAppSelector(selectProjectWritePermissions)
  const userRoleId = useAppSelector((state) => state.auth.userInfo?.role?.id)
  const { generateAllowed, externalAllowed } = invoiceAddPermissions(
    projectPermissions?.invoices,
    userRoleId
  )

  const noop = useCallback(() => {}, [])

  return (
    <div data-guide-target="project-invoices-panel">
      <ProjectViewInvoicesList
        persistColumnConfig={false}
        userId={userId}
        invoices={TOUR_DEMO_INVOICES}
        fetching={false}
        projectId={TOUR_DEMO_PROJECT_ID}
        selfAssigned={false}
        count={TOUR_DEMO_INVOICES.length}
        type={null}
        editableRow=""
        projectPermissions={projectPermissions}
        voidAllowed={false}
        generateAllowed={generateAllowed}
        externalAllowed={externalAllowed}
        options={{}}
        onOrderingChange={noop}
        onSelectRow={noop}
        onPageChange={noop}
        onLoadMore={noop}
        onAddInvoice={noop}
      />
    </div>
  )
}
